// extracted by mini-css-extract-plugin
export var planCard = "_vc-0";
export var planList = "_vc-1";